import React, { useEffect, useState } from 'react';
import '../UserHome/userHome.css';
import axios from 'axios';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';

const UserHome = () => {
  const [type, setType] = useState([]); 
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getType();
    getProperty();  
  }, []);

  const getType = () => {
    axios.get('https://pkrealestateapi.onrender.com/type/latest-type/3')
      .then(res => {
        console.log('Property Types:', res.data.Type); 
        setType(res.data.Type || []); 
      })
      .catch(err => {
        console.error('Error fetching property types:', err);
      });
  };

  const getProperty = () => {
    axios.get('https://pkrealestateapi.onrender.com/property/latest-post/4')
      .then(res => {
        console.log('Latest Properties:', res.data.properties); 
        setProperties(res.data.properties || []); 
      })
      .catch(err => {
        console.error('Error fetching properties:', err);
      });
  };

  return (
    <div>
      
      <div className="video-banner">
  <video autoPlay muted loop playsInline className="video-background">
    <source src="\Bgvideo.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="video-overlay">
    <h1>Welcome to P.K Real Estate</h1>
    <p>Your dream home awaits in 3D!</p>
  </div>
</div>

      <div className="section-header">
  <h1 className='heading'>🏠 Explore the Newest Listings</h1>
  <p className="subheading">Hand-picked properties just added for you.</p>
</div>
      <div className='latest-properties-container'>
        {properties.length > 0 ? properties.map(data => (
          <div 
          className='property-card' 
          key={data._id}
          onClick={() => navigate(`/uhome/property/${data._id}`)} // <-- added
          style={{ cursor: 'pointer' }}
        >
            <img className='property-image' alt='property' src={data.imageUrl} />
            <h2 className='property-name' >{data.name}</h2>
            <p className='property-type' >Type: {data.type}</p>
            <p className='property-location' >Location: {data.location}</p>
            <p className='property-price' >Price: ₹{new Intl.NumberFormat('en-IN').format(data.price)}</p> 
          </div>
        )) : <p>No properties available.</p>} 
      </div>

      <div className="virtual-tour-section">
  <h2 className="heading">🕶️ Virtual Home Tour</h2>
  <iframe
    src="https://my.matterport.com/show?play=1&lang=en-US&m=z89TWxj8LYF"
    width="100%"
    height="480"
    frameBorder="0"
    allowFullScreen
    title="3D Virtual Tour"
  ></iframe>
</div>
      
      <div className="section-header">
  <h1 className='heading'>🏷️ Trending Property Categories</h1>
  <p className="subheading">Discover the most popular types in demand.</p>
</div>
      <div className='Property-type-container'>
        {type.length > 0 ? type.map(data => (
          <div className='property-card' key={data._id}>
            <img className='Property-type-image' src={data.imageUrl} alt={data.name} />
            <p>{data.name}</p>
          </div>
        )) : <p>No property types available.</p>} 
      </div>
      <Footer/>
    </div>
  );
}

export default UserHome;